import { render, staticRenderFns } from "./ComparisonColumns.vue?vue&type=template&id=6eddff7e&"
import script from "./ComparisonColumns.vue?vue&type=script&lang=js&"
export * from "./ComparisonColumns.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonColumns.vue?vue&type=style&index=0&id=6eddff7e&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports